import React from "react";
import { Navigate, Outlet, useLocation } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { useAuth } from "../context/AuthContext.jsx";

export default function ProtectedRoute({ children, requiredRoles }) {
    const { t } = useTranslation();
    const { user, roles = [], loading } = useAuth();
    const location = useLocation();

    if (loading) {
        return (
            <p className="text-center p-6">
                {t("auth.loadingStatus", "Loading authentication status...")}
            </p>
        );
    }

    if (!user) {
        return <Navigate to="/login" replace state={{ from: location }} />;
    }

    if (requiredRoles && requiredRoles.length) {
        const required = Array.isArray(requiredRoles) ? requiredRoles : [requiredRoles];
        const hasAccess = required.some((r) => roles.includes(r));
        if (!hasAccess) return <Navigate to="/" replace />;
    }

    return children ?? <Outlet />;
}